'use client';

import { useAtomValue } from 'jotai';
import { tokenInitializedAtom } from '@/store';

interface TokenInitializedGuardProps {
  children: React.ReactNode;
}

/**
 * TokenInitializedGuard 组件
 * 确保 token 初始化完成后再渲染 children
 */
export default function TokenInitializedGuard({ children }: TokenInitializedGuardProps) {
  const isTokenInitialized = useAtomValue(tokenInitializedAtom);

  // 如果 token 还未初始化完成，不渲染 children
  if (!isTokenInitialized) {
    return null;
  }

  return <>{children}</>;
}

